import { Button, Col, Row, Table, Tag } from "antd"
import { FormatNumber } from "../../ValueObjects"
import { useForm } from "antd/lib/form/Form";
import { useEffect, useState } from "react";

export default function TabDetalheVeiculo({ veiculo }) {

    const [dados, setDados]= useState([])


useEffect(() =>{

let listaTemp = []
listaTemp.push(veiculo)
setDados(listaTemp)

}, [veiculo])

    return (
        <div className="tabela">
            <Table dataSource={dados} columns={
                [
                    {
                        title: 'Descrição',
                        render: ({ vec_descricao }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                        <b>{vec_descricao}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Placa',
                        render: ({ vec_placa }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                        <b>{vec_placa}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Marca',
                        render: ({ mav_descricao }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                       <b>{mav_descricao}</b> 
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Modelo',
                        render: ({ vec_modelo }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                    <b>{vec_modelo}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Cor',
                        render: ({ vec_cor }) => (
                            <div>
                                <Row align="middle"  gutter={[5, 5]}>
                                    <Col>
                                        <b>{vec_cor}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]
            } />
        </div>
    );
}